import React, {useState} from 'react';
import {FieldArray, useFormikContext} from "formik";
import useStyles from "../styles";
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import PopOverInfo from "../../../../../PopOverInfo";
import {Grid, Button, Typography} from '@material-ui/core';
import ClearIcon from "@material-ui/icons/Clear";
import ThumbAffinity from "../../../../../ThumbAffinity";
import {VscCloudUpload} from "@react-icons/all-files/vsc/VscCloudUpload";



export default function CoberturaFormMobile(props) {
    const classes = useStyles();
    const {
        formField: {tipoSeguro, comentario, uploadedFile, idProducto}, productOtros
    } = props;
    const {setFieldValue, values} = useFormikContext();


    const [selectedProduct, setSelectedProduct] = useState(values.idProducto);

    const handleProductSelectedChange = (e) => {
        setSelectedProduct(e.target.value);
        setFieldValue(idProducto.name, e.target.value)
        setFieldValue(tipoSeguro.name, productOtros[e.target.value].Nombre)
    };

    const handleChange = (e) => {
        if (e.target.name === idProducto.name) {
            values.idProducto = e.target.id;
        } else {
            values.comentario = e.target.value;
        }
    };

    return (
        <React.Fragment>
            <div style={{display: "flex", flexDirection: "column"}}>
                <div style={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-around",
                    marginBottom: "20px"
                }}>
                    <div style={{display: "flex", flexDirection: "column", width: "90%"}}>
                        <FormControl>
                            <p className={classes.radioButtonsTitle}>
                                Seguros Disponibles
                            </p>
                            <RadioGroup
                                aria-labelledby="demo-controlled-radio-buttons-group"
                                name="controlled-radio-buttons-group"
                                value={selectedProduct}
                                onChange={handleProductSelectedChange}
                            >
                                {productOtros.map((product) => (
                                    <div style={{
                                        display: "flex",
                                        flexDirection: "row",
                                        justifyContent: "space-between",
                                    }}>
                                        <FormControlLabel value={product.idProducto}
                                                          control={<Radio
                                                              style={{marginRight:"4px"}}
                                                              key={product.idProducto}
                                                              sx={{
                                                                  color: "#BB0D66",
                                                                  '&.Mui-checked': {
                                                                      color: "#BB0D66",
                                                                  },
                                                              }}
                                                          />}
                                                          label={product.Nombre}/>
                                        <PopOverInfo
                                            descripcion={product.Descripcion}
                                            isMobile={true}/>
                                    </div>
                                ))}

                            </RadioGroup>
                        </FormControl>
                    </div>
                </div>
                <div style={{display: "flex", flexDirection: "row", justifyContent: "space-around"}}>
                    <div
                        style={{
                            display: "flex",
                            flexDirection: "column",
                            width: "80%"
                        }}
                    >
                        <label
                            className={classes.radioButtonsTitle}
                            style={{marginBottom:"16px"}}
                        >
                            Agregue información adicional
                        </label>
                        <textarea
                            className={classes.inputTextArea}
                            placeholder="Comentarios"
                            name={comentario.name}
                            onChange={handleChange}
                        />

                        <label
                            className={classes.EncodeSansFont}
                            style={{
                                fontSize: "14px",
                                marginBottom: "15px",
                                marginTop: "15px",
                                maxWidth: "250px",
                                textAlign: "start",
                            }}
                        >
                           Subí tu póliza actual y accedé a un mejor precio
                        </label>

                        <div style={{
                            padding: '16px', width: '100%', border: '0.5px dashed #7F7F7F',
                            borderRadius: '8px',
                        }}>
                            <Grid item xs={12} style={{display:'flex', justifyContent:'center'}}>
                                {(values.archivos.length < 6) && (

                                    <Button
                                        variant="contained"
                                        component="label"
                                        className={classes.buttonForm}
                                        style={{
                                            marginBottom: '20px',
                                            backgroundColor: '#BB0D66',
                                            textTransform:'none',

                                        }}
                                    >
                                        <Typography style={{color: '#fff', display:'flex', alignItems:'center'}}>
                                            <VscCloudUpload style={{
                                                fontSize:'20px',
                                                marginRight:'8px'
                                            }}/>
                                            {values.archivos.length === 0 ? 'Subir Archivo' : 'Subir Otro Archivo'}
                                        </Typography>
                                        <input id="file" name="file" type="file" hidden
                                               onChange={(event) => {
                                                   if (event.currentTarget.files[0] !== undefined) {
                                                       let jsonFile = {
                                                           "name": event.currentTarget.files[0].name,
                                                           "content": "",
                                                           "filetype": event.currentTarget.files[0].type,
                                                           "file": event.currentTarget.files[0]
                                                       };
                                                       setFieldValue('archivos', values.archivos.concat(jsonFile));
                                                   }
                                               }}
                                               accept="application/pdf,image/x-png,image/jpeg"
                                        />
                                    </Button>
                                )}

                            </Grid>
                            <Grid xs={12} style={{display: 'flex', maxWidth: '200px', overflow: 'auto'}}>
                                <FieldArray name='archivos'>{({remove}) => (
                                    values.archivos.map((file, index) => {
                                        return (
                                            <Grid item xs={6}>
                                                <ThumbAffinity index={index} values={values} file={file.file}/>
                                                <Button onClick={() => remove(index)}><ClearIcon/></Button>
                                            </Grid>
                                        )
                                    })
                                )}</FieldArray>
                            </Grid>
                        </div>

                    </div>


                </div>

            </div>

        </React.Fragment>
    );
}
